import Swiper, { Pagination, Lazy, EffectFade, Navigation } from "swiper";
import Subscribe from "../modules/subscribe";

const Home = {
  init() {
    Subscribe.init();
    this.relatedProductsSlider();
  },

  bannerSlider() {
    const heroEl = $(".hero-slider");

    if (!heroEl.length) {
      return;
    }

    const pagerEl = heroEl.find(".swiper-pagination");

    new Swiper(heroEl[0], {
      modules: [Pagination, Lazy, EffectFade],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: pagerEl[0],
        clickable: true,
      },
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      effect: "fade",
    });
  },

  relatedProductsSlider() {
    const wrapEl = $(".related");
    if (wrapEl.length) {
      let swiperInstance;

      function initializeSwiper() {
        swiperInstance = new Swiper(wrapEl.find(".related__slider")[0], {
          modules: [Lazy, Navigation],
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1,
          },
          navigation: {
            prevEl: wrapEl.find(".slider-nav__btn-prev")[1],
            nextEl: wrapEl.find(".slider-nav__btn-next")[1],
          },
          slidesPerView: "auto",
          spaceBetween: 16,
          loop: false,
          breakpoints: {
            900: {
              navigation: {
                prevEl: wrapEl.find(".slider-nav__btn-prev")[0],
                nextEl: wrapEl.find(".slider-nav__btn-next")[0],
              },
            }
          }
        });
      }

      initializeSwiper(); // Initialize Swiper initially

      // Update Swiper on window resize
      $(window).on('resize', function () {
        // Destroy previous instance if it exists
        if (swiperInstance) {
          swiperInstance.destroy();
        }
        // Reinitialize Swiper with updated options
        initializeSwiper();
      });
    }
  }


};

export default Home;
